import React from "react";
import { Col, Row } from "react-bootstrap";
import LoadCatalogs from "../../../components/load-catalogs/LoadCatalogs";

const Catalogs = () => {
  return (
    <Row className="h-100">
      <Col col={12} className="col-12 mb-4">
        <LoadCatalogs />
      </Col>
    </Row>
  );
};

export default Catalogs;
